import api from '../../api';

export const SET_SUBSCRIBE_LOADING = 'SET_SUBSCRIBE_LOADING';
export const SET_SUBSCRIBE = 'SET_SUBSCRIBE';

export const setSubscribeLoading = (loading) => ({
	type: SET_SUBSCRIBE_LOADING,
	payload: loading,
});

export const setSubscribe = (subscribe) => ({
	type: SET_SUBSCRIBE,
	payload: subscribe,
});

export function getSubscriptionInfoAction() {
	return async function getSubscriptionInfo(dispatch) {
		dispatch(setSubscribeLoading(true));
		try {
			const res = await api.getSubscriptionInfo();
			if (res.data.subscription) {
				dispatch(setSubscribe({ ...res.data.subscription }));
			} else {
				console.error({ res });
			}
		} catch (error) {
			console.log({ error });
		} finally {
			dispatch(setSubscribeLoading(false));
		}
	};
}
